import { isAfter } from 'date-fns'
import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker, FormError, FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { SchemaType } from '@/components/forms/RunRiskCalibrationForm/RunRiskCalibrationForm.schema'

export interface ValueDateFieldProps {}

export const ValueDateField: React.FC<ValueDateFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<SchemaType>()

  return (
    <FormField
      name="value_date"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Value Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              disabled={(date) => isAfter(date, new Date())}
              selected={value ? new Date(value) : undefined}
              onSelect={(value) =>
                value && setValue('value_date', toISO8601(value), { shouldValidate: true })
              }
            />
          </FormItem>
        )
      }}
    />
  )
}
